'use strict';

import React, { Component } from 'react'

import Button from '@material-ui/core/Button'

import Image from '@Pure/Image'

const app = window.app;

export default class FloatingCard extends Component
{
	state =
	{
		loading: false
	};

	openModal = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		app.emit('open__UserCardModal');
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let output =
		(
			<Button type="button" className="c-floating-card"
				onClick={ component.openModal }>
				<Image className="c-floating-card__icon"
					src="/images/carte_synergies_2026.png"
				/>
			</Button>
		);

		return output;
	}
}